export function validateGrabCents(data) {
  const {
    grabCentsMode,
    percentagePerLevel,
    quantityPerLevel,
    centsPerLevel,
    trailPercent,
    trailQuantity,
    trailAmount,
  } = data;

  if (!centsPerLevel || centsPerLevel.length === 0)
    return [false, 'Must have at least one defined cents level.'];
  if (grabCentsMode === 'percentage') {
    if (!percentagePerLevel || percentagePerLevel.length === 0)
      return [false, 'Must have at least one defined percentage per level.'];
    if (percentagePerLevel.length !== centsPerLevel.length)
      return [
        false,
        'Cents and Percentages must have an equal number of items.',
      ];
    for (const percentage of percentagePerLevel) {
      if (percentage > 1 || percentage < 0)
        return [false, 'Percentages must be between 0 and 100.'];
    }
    const percentageSet = new Set(percentagePerLevel);
    if (percentageSet.size !== percentagePerLevel.length)
      return [
        false,
        'Cannot enter duplicate profit values, please make sure each level has a unique profit value.',
      ];
    if (trailPercent !== 0 && trailAmount <= 0)
      return [
        false,
        'If trail quantity is larger than zero, trail distance must be larger than zero.',
      ];
    return [true, ''];
  } else {
    if (!quantityPerLevel || quantityPerLevel.length === 0)
      return [false, 'Must have at least one defined quantity per level.'];
    if (quantityPerLevel.length !== centsPerLevel.length)
      return [
        false,
        'Cents and quantities must have an equal number of items.',
      ];
    for (const quantity of quantityPerLevel) {
      if (quantity < 0) return [false, 'Quantities must be larger than 0'];
    }
    const quantitySet = new Set(quantityPerLevel);
    if (quantitySet.size !== quantityPerLevel.length)
      return [
        false,
        'Cannot enter duplicate profit values, please make sure each level has a unique profit value.',
      ];
    if (trailQuantity !== 0 && trailAmount <= 0)
      return [
        false,
        'If trail quantity is larger than zero, trail distance must be larger than zero.',
      ];
    return [true, ''];
  }
}
